import React, { useState, useRef } from "react";
import f1 from "../img/f1.png";
import eye from "../img/eye.png";
import { useNavigate } from "react-router-dom";
import { handleAddUserRequest } from "../components/userRequests";

const CreateAccountPage = ({
  // Importing all of my states that I need from App.js
  isPayment,
  name,
  email,
  password,
  confirmPassword,
  setName,
  setEmail,
  setPassword,
  setConfirmPassword,
}) => {
  // Initialising useNavigate + useRef
  const navigate = useNavigate();
  const passwordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const emailRef = useRef(null);

  // Defining states which are only used on this page
  const [isPasswordHidden, setIsPasswordHidden] = useState(false);
  const [invalidFields, setInvalidFields] = useState({
    email: false,
    password: false,
    confirmPassword: false,
  });

  // Function to go through all of the validation of my inputs
  const validateInputs = () => {
    // If passwords match
    if (arePasswordsEqual()) {
      // If email is valid
      if (isEmailValid()) {
        return true;
      }
      return "Invalid Email Format";
    }
    return "Passwords do not match";
  };

  // Returns if the password and confirm password inputs are equal
  const arePasswordsEqual = () => {
    if (password === confirmPassword) return true;
  };

  // Returns the result of the email entered compared to the regex
  const isEmailValid = () => {
    // Use a regex to check if the email is valid
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  // Entry function called when submit button is pressed
  const handleClick = () => {
    // Resetting all of the inputs
    setInvalidFields({ email: false, password: false, confirmPassword: false });

    // Accessing the result of the validateinputs function
    const areInputsValid = validateInputs();
    // If true isnt returned (there is an error)
    if (areInputsValid !== true) {
      // Alerting the user of the error that has occured
      alert(areInputsValid);
      // If it equals passwords do not match
      if (areInputsValid === "Passwords do not match") {
        setInvalidFields((prev) => ({
          ...prev,
          password: true,
          confirmPassword: true,
        }));
      } else {
        // The other input is the problem, in this case it is the email
        setInvalidFields((prev) => ({ ...prev, email: true }));
      }
    } else {
      // All inputs are valid -> redirect to correct page depending on what plan was selected
      handleAddUserRequest();
      isPayment ? handlePaymentRedirect() : navigate("/dashboard");
    }
  };

  const handleLoginRedirectClick = () => {
    navigate("/login");
  };

  const handlePaymentRedirect = () => {
    navigate("/payment");
  };

  // Function to handle the addition of users
  const handleAddUserRequest = async () => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/add-user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name,
        email: email,
        password: password,
        premium: false,
      }),
    });
    const data = await response.json();

    if (data.message === undefined) {
      alert("Add user failed:", data);
      navigate("/");
      return;
    }

    console.log(data.message);

    // Validating what the error was (if there was an error)
    if (data.message.status === "User cookie set successfully") {
      // If not, storing the access token into local storage so it can be retrieved later
      handleSuccessfulLogin(data);
    } else if (data.message.status === "User not authenticated") {
      alert("Your account is not verified");
      navigate("/email-confirmation");
    } else if (data.message.status === "User not found") {
      // If user does not exist
      setInvalidFields((prev) => ({ ...prev, email: true }));
    } else {
      // If user has an account
      if (data.message == `The email ${email} is signed up with and account`) {
        alert("Email already exists. Please log in.");
        navigate("/login");
        setInvalidFields((prev) => ({ ...prev, email: true }));
      } else {
        // Password is incorrect
        setInvalidFields((prev) => ({
          ...prev,
          password: true,
          confirmPassword: true,
        }));
      }
    }
  };

  const handleSuccessfulLogin = async (data) => {
    localStorage.setItem("sb_id", JSON.stringify(data.message.user));
    navigate("/email-confirmation");
  };

  // JSX which is returned
  return (
    <div className="form-container">
      <form className="form" onSubmit={(e) => e.preventDefault()}>
        <div className="form-header">Sign up to TelemetryLab</div>

        <input
          className="input"
          type="text"
          id="fname"
          name="fname"
          placeholder="Full Name..."
          value={name}
          required
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="text"
          name="email"
          ref={emailRef}
          placeholder="Email Address..."
          className={invalidFields.email ? "input-error" : "input"}
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
        />
        <div className="password-input">
          <input
            className={invalidFields.password ? "input-error" : "input"}
            type={isPasswordHidden ? "text" : "password"}
            ref={passwordRef}
            name="password"
            placeholder="Password..."
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            className="hide-button"
            onClick={(e) => {
              e.preventDefault();
              setIsPasswordHidden((prev) => !prev);
            }}
          >
            <img src={eye} />
          </button>
        </div>
        <div className="confirm-password">
          <input
            className={invalidFields.confirmPassword ? "input-error" : "input"}
            type={isPasswordHidden ? "text" : "password"}
            ref={confirmPasswordRef}
            name="confirm-password"
            placeholder="Confirm Pasword..."
            value={confirmPassword}
            required
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <button
            className="hide-button"
            onClick={(e) => {
              e.preventDefault();
              setIsPasswordHidden((prev) => !prev);
            }}
          >
            <img src={eye} />
          </button>
        </div>
        <input
          type="submit"
          id="submit"
          name="submit"
          value={isPayment ? "Continue to payment" : "Start analysing"}
          onClick={handleClick}
        />
        {invalidFields.email && (
          <input
            type="submit"
            id="login-redirect"
            name="login-redirect"
            value={`The email ${email} already exists. Click here to log in`}
            onClick={handleLoginRedirectClick}
          />
        )}
      </form>

      <div className="image-container">
        <img src={f1} />
      </div>
    </div>
  );
};

export default CreateAccountPage;
